import PropTypes from 'prop-types'
import React from 'react'
import { sitemap } from '../../../content/sitemap'
import Column from '../../layouts/Column'
import Row from '../../layouts/Row'
import Spacer from '../../layouts/Spacer'
import ContactArea from '../ContactArea'
import Logo from '../Logo'
import PageLink from '../PageLink'
import './styles.scss'

const Footer = ({ location, lang }) => (
  <footer className="footer">
    <div className="footer__inner">
      <Row align="stretch" width="large">
        <Column span={12} spanWhen={{ md: 6, lg: 7 }}>
          <div className="footer__contact">
            <Logo />
            <div className="footer__contact__desktop">
              <ContactArea />
            </div>
          </div>
        </Column>
        <Column span={6} spanWhen={{ md: 3 }} shift="l" shiftWhen={{ md: 'z' }}>
          <ul className="footer__nav">
            {sitemap.column_1.map((link, index) => (
              <li className="footer__nav__item" key={'column_1_' + index}>
                <PageLink to={link[lang].to} active={location.pathname === link[lang].to ? true : false}>
                  {link[lang].name}
                </PageLink>
              </li>
            ))}
          </ul>
        </Column>
        <Column span={6} spanWhen={{ md: 3, lg: 2 }} shift="l" shiftWhen={{ md: 'z' }}>
          <ul className="footer__nav">
            {sitemap.column_2.map((link, index) => (
              <li className="footer__nav__item" key={'column_2_' + index}>
                <PageLink to={link[lang].to} active={location.pathname === link[lang].to ? true : false}>
                  {link[lang].name}
                </PageLink>
              </li>
            ))}
          </ul>
        </Column>
        <Column span={12}>
          <div className="footer__contact__mobile">
            <Spacer size="m" />
            <ContactArea />
          </div>
        </Column>
      </Row>
    </div>
  </footer>
)

Footer.propTypes = {
  location: PropTypes.object.isRequired,
  lang: PropTypes.string.isRequired
}

export default Footer
